import Image from 'next/image'
import { css, Theme } from '@emotion/react'

type Props = {
  client: string
  title: string
  category: string[]
  src1: string
  src2: string
}

const WorksHero: React.FC<Props> = ({
  client,
  title,
  category,
  src1,
  src2,
}) => {
  return (
    <>
      <section css={styles.hero}>
        <div css={styles.bg1}>
          <Image src={src1} alt='bg' layout='fill' objectFit='cover' />
        </div>
        <div css={styles.bg2}>
          <Image src={src2} alt='bg' layout='fill' objectFit='cover' />
        </div>
        <div css={styles.title_container}>
          <h2 css={styles.client}>{client}</h2>
          <h1 css={styles.title}>{title}</h1>
          <div css={styles.categoryContainer}>
            {category.map(item => (
              <h3 css={styles.category} key={item}>
                {item},
              </h3>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

const styles = {
  hero: css`
    position: relative;
    height: 60vh;
    min-height: 800px;
    @media (max-width: 960px) {
      min-height: calc(500px + 80vw);
    }
  `,
  bg1: css`
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    &:before {
      position: absolute;
      z-index: 10;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
    }
  `,
  bg2: css`
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    &:before {
      position: absolute;
      z-index: 10;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
    }
    @media (max-width: 960px) {
      display: none;
    }
  `,
  title_container: css`
    position: absolute;
    z-index: 20;
    width: 100%;
    top: 40%;
    left: 50%;
    color: white;
    max-width: 1080px;
    padding: 100px 0 100px;
    transform: translate(-50%);
    @media (max-width: 960px) {
      top: 50%;
      width: 80vw;
      padding: 0 40px;
    }
  `,
  client: css`
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 1.2rem;
    @media (max-width: 1200px) {
      font-size: 1.625vw;
    }
    @media (max-width: 960px) {
      font-size: 2.75vw;
    }
  `,
  title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 2rem;
    @media (max-width: 1200px) {
      font-size: 2.5vw;
      margin: 10px 0 20px;
    }
    @media (max-width: 960px) {
      font-size: 5vw;
    }
  `,
  categoryContainer: css`
    display: flex;
  `,
  category: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1rem;
    color: #c5c5c5;
    margin-right: 10px;
    @media (max-width: 1200px) {
      font-size: 1.5vw;
    }
    @media (max-width: 960px) {
      font-size: 2vw;
    }
  `,
}

export default WorksHero
